import * as http from 'utils/http';
import config from 'config';
import serialize from 'utils/serialize';

const baseService = (serviceName, serviceParams = {}) => {
  return http.rawGet(`${config.POI_SERVICE_URL}${serviceName}?${serialize(serviceParams)}`);
};

export { baseService };
